import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import {
  QuickSelectInfoButton,
  type QuickSelectInfoButtonProps,
} from "./quick-select-info-button";

export const QuickSelectInfoIconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<QuickSelectInfoButtonProps>
>(({ size = "lg", className, children, ...props }, ref) => {
  return (
    <QuickSelectInfoButton
      ref={ref}
      className={clsx(
        "rounded-md p-0",
        {
          "w-8": size === "sm",
          "w-9": size === "lg",
        },
        className,
      )}
      size={size}
      {...props}
    >
      {children}
    </QuickSelectInfoButton>
  );
});
